import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=21aef3f6&"
import script from "./BankCard.vue?vue&type=script&lang=js&"
export * from "./BankCard.vue?vue&type=script&lang=js&"
import style0 from "./BankCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports